<template>
    <el-container class="recharge">

        <el-header class="search">

            <el-select v-model.number="questionSource" placeholder="来源" style="width: 125px; margin:0 10px 0 -20px"
                @change="BtnQuery">
                <el-option v-for="item in questionSourceData" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
            </el-select>

            <el-input class="search-text" v-model="keyWord" placeholder="请输入关键字检索..." @keyup.enter.native="BtnQuery">
            </el-input>
            <el-button type="primary" size="medium" plain icon="el-icon-search" @click="BtnQuery">查询</el-button>
        </el-header>

        <el-main>
            <div v-if="questionData.length > 0" class="question-data">
                <div v-for="(item,i) in questionData" :key='i'>
                    <div class="descript xy-between">
                        <div class="left ">
                            <div class="collectTit two-wrap" v-if="item.SubjectNameNew" v-html="item.SubjectNameNew">
                            </div>
                            <div class="jf">
                                <div>类别：{{item.ClassName}}</div>
                                <div class="makeTopicTime">收藏时间：{{item.CreateTime}}</div>
                            </div>
                        </div>
                        <div class="right jf">
                            <el-tag size="small" type="danger" class="table-btn" @click="DelCollect(item)">
                                取消收藏
                            </el-tag>
                            <el-tag size="small" class="table-btn" @click="DoQuestion(item)">
                                重做
                            </el-tag>
                        </div>
                    </div>
                </div>
            </div>
            <empty-data v-else></empty-data>
        </el-main>

        <el-footer v-if="questionData.length > 0" class="pagaing">
            <el-pagination :background="true" :current-page="pageIndex" :page-size="PageSize" :total="total"
                :layout="pageLayout" @current-change="PageChange" @size-change="SizeChange"></el-pagination>
        </el-footer>
    </el-container>
</template>

<script>
import {
    GetCollectQuestion,
    DelCollectRecord
} from "@/api/questionPaper";
import EmptyData from "@/components/EmptyData";
import { safeParseInt } from "@/utils";
import { SourceType } from "@/kernel";
import { CommonPage } from "@/mixins/commonData";

export default {
    components: {
        EmptyData
    },
    mixins: [CommonPage],
    data() {
        return {
            listLoading: false,
            loadingText: "正在加载...",
            pageLayout: "total, sizes, prev, pager, next, jumper",
            questionSourceData: [{
                value: 1,
                name: "公共题库"
            },
            {
                value: 2,
                name: "机构题库"
            }
            ],
            questionSource: 1,
            pageIndex: 1,
            PageSize: 10,
            total: 0,
            // 列表记录
            questionData: [],
            keyWord: "",
            AllQuestionData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        this.GetCollectQuestion()
    },
    methods: {
        // 试题重做2
        DoQuestion(val) {
            if (safeParseInt(val.SourceType) === SourceType.organ) {
                let obj = {}
                obj.type = "person"
                obj.info = this.AllQuestionData
                obj.currentTopic = val
                window.localStorage.setItem("TopicInfo", JSON.stringify(obj))
                this.$router.push("/publicMake?from=organ")
            } else {
                let obj = {}
                obj.info = this.AllQuestionData
                obj.type = "publicCollect"
                obj.currentTopic = val
                obj.libaryType = val.ClassName
                window.localStorage.setItem("TopicInfo", JSON.stringify(obj))
                this.$router.push("/publicMake")
            }
        },
        // 取消
        DelCollect(item) {
            this.$confirm("确认取消收藏?" + `<br/>${item.SubjectName}`, "提示", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.CancelCollect(item.Id)
            }).catch(() => {})
        },
        // 取消收藏
        async CancelCollect(questionId) {
            try {
                const {
                    data
                } = await DelCollectRecord({
                    CollectId: questionId,
                    type: 1
                })
                if (data.code === 100) {
                    this.$message({
                        message: "取消成功！",
                        type: "success"
                    })
                    if (this.needToPrePage({
                        page: this.pageIndex,
                        pageSize: this.PageSize,
                        total: this.total,
                        delCount: 1
                    })) {
                        this.pageIndex--;
                    }
                    await this.GetCollectQuestion()
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    })
                }
            } catch (error) {
                this.$message({
                    message: "服务器开小差了！",
                    type: "error"
                })
            }
        },

        // 试题列表
        async GetCollectQuestion() {
            const {
                data
            } = await GetCollectQuestion({
                pageno: this.pageIndex,
                pagesize: this.PageSize,
                sourceType: this.questionSource,
                searchkey: this.keyWord
            });
            var imgReg = /<img.*?(?:>|\/>)/gi;
            var brReg = /<br.*?(?:>|\/>)/gi;
            if (data.code === 100) {
                for (let item of data.data) {
                    item.SubjectName = item.SubjectName.replace(imgReg, "")
                    item.SubjectName = item.SubjectName.replace(brReg, "")
                    item.SubjectNameNew = " [" + item.SubjectTypeName + "] " + item.SubjectName
                }

                this.questionData = data.data
                this.total = data.count
                this.GetAllCollectQuestion();
            }
        },
        // 试题总列表
        async GetAllCollectQuestion() {
            const {
                data
            } = await GetCollectQuestion({
                pageno: 1,
                pagesize: 999999,
                sourceType: this.questionSource,
                searchkey: this.keyWord
            });
            if (data.code === 100) {
                for (let item of data.data) {
                    item.SubjectNameNew = " [" + item.SubjectTypeName + "] " + item.SubjectName
                }
                this.AllQuestionData = data.data
            }
        },
        // 按钮检索
        BtnQuery() {
            this.pageIndex = 1;
            this.PageSize = 10;
            this.GetCollectQuestion()
        },
        //
        PageChange(val) {
            this.pageIndex = val;
            this.GetCollectQuestion()
        },
        //
        SizeChange(val) {
            this.PageSize = val
            this.GetCollectQuestion()
        }
    }
}

</script>

<style scoped lang="less">
    .recharge {
        width: 100%;
        height: 100%;

        .el-main {
            padding: 0 0 5px 0;
            color: black;
            height: 600px;
            overflow: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 6px;
                background: #BAC0CA;
            }
        }

        .el-footer {
            margin-top: 40px;
            height: 50px;
            line-height: 50px;
            text-align: center;
        }

        .search {
            width: 100%;
            height: 40px;
            line-height: 40px;

            .search-select {
                width: 130px;
            }

            .search-text {
                width: 250px;
                margin: 0 20px 0 0;
            }

            ::v-deep .el-input__inner {
                height: 35px;
            }

        }

        .question-data {
            padding: 10px 0 -10px 0;
            color: black;

            .table-btn {
                cursor: pointer;
                margin: 0 5px 0 5px;
            }

            .descript {
                height: 80px;
                border-bottom: 1px solid #e5e8ec;
                padding: 10px 20px 10px 10px;
                box-sizing: border-box;

                .left {
                    height: 100%;
                    display: flex;
                    flex-flow: column;
                    justify-content: space-between;

                    .makeTopicTime {
                        margin-left: 130px;

                    }
                }
            }

            ::v-deep .el-descriptions__header {
                margin: 10px 0 5px 0;
            }

            ::v-deep .el-descriptions__title {
                width: 80%;
                font-size: 15px;
                word-wrap: break-word;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .collectTit {
                width: 90%;
                font-weight: bold;
                font-size: 14px;
            }
        }

    }

</style>
